import { autoBootstrap, exposeGlobalApi } from './bootstrap.js';

exposeGlobalApi();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', autoBootstrap);
} else {
  autoBootstrap();
}
